import Button from './components/Button/Button.vue';
import Checkbox from './components/Checkbox/Checkbox.vue';
import Input from './components/Input/Input.vue';
import Pills from './components/Pills/Pills.vue';
import Popover from './components/Popover/Popover.vue';
import Select from './components/Select/Select.vue';
import SelectOption from './components/Select/SelectOption.vue';
import Spinner from './components/Spinner/Spinner.vue';
import Tabs from './components/Tabs/Tabs.vue';

import clickoutside from './directives/clickoutside.js';
import tooltip from './directives/tooltip.js';
import localization from './locale/index.js';

export {
    Button as ActivixButton,
    Checkbox as ActivixCheckbox,
    Input as ActivixInput,
    Pills as ActivixPills,
    Popover as ActivixPopover,
    Select as ActivixSelect,
    SelectOption as ActivixSelectOption,
    Spinner as ActivixSpinner,
    Tabs as ActivixTabs,
    localization,
};

export default {
    install(Vue, { locale = 'en', oldFontScale = false } = {}) {
        if (this.installed) {
            return;
        }

        this.installed = true;

        localization.use(locale);
        Vue.directive('clickoutside', clickoutside(Vue));
        Vue.directive('tooltip', tooltip(Vue));

        const ui = { oldFontScale };

        Vue.ui = ui;
        Vue.prototype.$ui = ui;
    },
};
